import { render, staticRenderFns } from "./Statictics.vue?vue&type=template&id=1d24dd46&scoped=true"
import script from "./Statictics.vue?vue&type=script&lang=js"
export * from "./Statictics.vue?vue&type=script&lang=js"
import style0 from "./Statictics.vue?vue&type=style&index=0&id=1d24dd46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d24dd46",
  null
  
)

export default component.exports